/* ── Environment variables (single source of truth) ── */
export const DEBUG = import.meta.env.VITE_DEBUG === 'true'
export const ENVIRONMENT = import.meta.env.VITE_ENV as string
export const GCLOUD_PROJECT = import.meta.env.VITE_GCLOUD_PROJECT as string
export const CARTO_CONNECTION = import.meta.env
  .VITE_CARTO_CONNECTION_BQ as string
export const CARTO_API_BASE_URL =
  (import.meta.env.VITE_CARTO_API_BASE_URL as string) ||
  'https://gcp-us-east1.api.carto.com'
export const CARTO_APP_NAME = import.meta.env.VITE_APP_NAME as string
export const CARTO_CLIENT_ID = import.meta.env.VITE_CLIENT_ID as string
export const CARTO_ORGANIZATION_ID = import.meta.env.VITE_CARTO_ORG_ID as string
export const CF_API_SERVICES = import.meta.env.VITE_CF_API_SERVICES as string
export const ROUTING_ENGINE_URL = import.meta.env
  .VITE_ROUTING_ENGINE_URL as string
export const CACHE_CONTROL = import.meta.env.VITE_CACHE_CONTROL as string
export const MAX_RADIUS_DROP_A_PIN = import.meta.env
  .VITE_MAX_RADIUS_DROP_A_PIN as number
export const CARTO_COMPARE_MAPS_DATASET = import.meta.env
  .VITE_CARTO_COMPARE_MAPS_DATASET as string
export const GOOGLE_MAPS_API = import.meta.env.VITE_GOOGLE_MAP_API_KEY as string
export const GOOGLE_MAPS_ID = import.meta.env.VITE_GOOGLE_MAP_ID as string
export const GOOGLE_GEOCODER_API = import.meta.env
  .VITE_GOOGLE_GEOCODER_API_KEY as string
export const SERVICE_PREFIX = import.meta.env.VITE_SERVICE_PREFIX as string
export let STATIC_ACCESS_TOKEN = import.meta.env.VITE_ACCESS_TOKEN as string
export const CARTO_ACCESS_TOKEN = import.meta.env
  .VITE_CARTO_ACCESS_TOKEN as string

export const AI_AGENT_WEBSOCKET_URL =
  (import.meta.env.VITE_AI_AGENT_WEBSOCKET_URL as string) ||
  'ws://localhost:3003/ws'

// URL of the AI Assistant demo video. Defaults to the MP4 bundled in
// public/media/; set the env var to a direct video-file URL to override it.
// The manual renders a native <video>, so iframe embed URLs won't work here.
export const VIDEO_TUTORIAL_URL =
  (import.meta.env.VITE_VIDEO_TUTORIAL_URL as string) ||
  `${import.meta.env.BASE_URL}media/ai-assistant-demo.mp4`

export function setDynamicSettings({
  accessToken,
}: {
  accessToken: string | null
}) {
  STATIC_ACCESS_TOKEN = accessToken ?? STATIC_ACCESS_TOKEN
}

export const H3_RESOLUTION = 8

export const DATASET_APP = 'app'
export const TABLE_PREFIX = GCLOUD_PROJECT + '.' + DATASET_APP
export const PROCEDURE_PREFIX = GCLOUD_PROJECT + '.model'

export const TABLE_H3_TOPICS = 'h3_topics'
export const TABLE_H3_WEIGHT = 'h3_weight'
export const TABLE_H3_SCALED = 'h3_scaled'
export const TABLE_H3_INDEXES = 'h3_indexes'
export const TABLE_H3_BOUNDARIES = 'h3_boundaries'
export const TABLE_BOUNDARIES = 'boundaries_default'
export const TABLE_HAWAII_BOUNDARIES = 'hawaii_boundaries'
export const TABLE_BOUNDARIES_USER_DRAWN = 'boundaries_user_drawn'
export const TABLE_PREDICTION_CRASHES = 'h3_expected_crashes'
export const TABLE_FORECAST_CRASHES = 'h3_forecasted_crashes'
export const TABLE_LIVES_SAVED = 'h3_lives_saved'
export const TABLE_H3_SPEED_LIMIT = 'h3_hdot_speed_limit'
export const TABLE_FARS = 'fars_crash'
export const TABLE_SHACA = 'shaca_crash'
export const TABLE_MOOVE_AI_DRIVER_EVENTS = 'hard_brakings_events'
export const TABLE_H3_HERE_SEGMENTS = 'h3_here_segments'
export const TABLE_RAISED_CROSSWALKS = 'hdot_raised_crosswalks'

export const PROCEDURE_BOUNDARIES_USER_DRAWN_INSERT = 'user_drawn_insert'

export const TABLE_MOOVE_PREFIX =
  GCLOUD_PROJECT + '.hidot_safety_moove_ai_reporting'
export const TABLE_MOOVE_AI_VEHICLE = 'segment_how_agg_vehicle_movements_USA_HI'
export const TABLE_MOOVE_AI_VEHICLE_MOVEMENTS = 'vehicle_movement_stats'
export const TABLE_MOOVE_AI_ROAD_SEGMENTS = 'road_segments'

export const TABLE_PREFIX_COMPARISON =
  GCLOUD_PROJECT + '.' + CARTO_COMPARE_MAPS_DATASET
export const TABLE_CORRIDORS = 'corridors'
export const TABLE_CORRIDORS_SEGMENTS = 'corridors_segments'
export const TABLE_COUNTERMEASURES_LINES = 'countermeasures_lines'
export const TABLE_COUNTERMEASURES_POINTS = 'countermeasures_pts'
export const TABLE_COUNTERMEASURES_NEAR_ROAD_SEGMENTS =
  'countermeasures_near_road_segments'
export const TABLE_CRASHES = 'crashes'
export const TABLE_CRASHES_NEAR_ROAD_SEGMENTS = 'crashes_near_road_segments'
export const TABLE_SEGMENTS = 'roadway_network_geom'
export const TABLE_ROADWAY_NETWORK_STATS = 'roadway_network_stats'
export const TABLE_STATS_SUMMARY_MIN_MAX_BY_SEGMENT =
  'stats_summary_min_max_by_segment'
export const TABLE_STATS_SUMMARY_TS_BY_SEGMENT = 'stats_summary_ts_by_segment'
